import { takeLatest, all } from 'redux-saga/effects';

import { requestAndSet } from 'utils/helpers';

import { visitorTypesActions as actions } from '../slices/visitorTypesSlice';

function* fetchVisitorTypesSaga(
  action: ReturnType<typeof actions.fetchVisitorTypes>,
): Generator {
  const { orgId } = action.payload;

  yield requestAndSet('getVisitorTypes', [orgId], {
    createSetterAction: actions.setVisitorTypes,
    loadingAction: (v: boolean) =>
      actions.setLoading({ key: 'fetchVisitorTypesLoading', value: v }),
  });
}

export default function* visitorTypesSaga(): Generator {
  yield all([
    takeLatest(actions.fetchVisitorTypes.type, fetchVisitorTypesSaga),
  ]);
}
